export enum OrderInvoiceStatus {
    NotApplicable = -1,
    Pending = 0,
    Open = 1,
    Started = 2,
    Completed = 3
}

export const OrderInvoiceStatusMetadata = {
    '-1': {
        display: 'Not Applicable',
        class: 'na',
        value: -1
    },
    '0': {
        display: 'Pending',
        class: 'waiting',
        value: 0
    },
    '1': {
        display: 'Open',
        class: 'waiting',
        value: 1
    },
    '2': {
        display: 'Started',
        class: 'inprogress',
        value: 2
    },
    '3': {
        display: 'Completed',
        class: 'done',
        value: 3
    }
};
